module.exports = __webpack_public_path__ + "static/mongodb-query-optimization-02-9dded1d5daf9900441d6e023dfabe8f5.png";